import { DefaultProductOptions } from '../analytics-context-types';
import { getPODModalTag, getPODProductTag } from './utils';

export const getReturnToEditTag = (options: DefaultProductOptions) => {
  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );

  const returnToEditModalEvent = [
    {
      eventInfo: {
        eventName: 'Return to Edit Card',
        eventAction: 'Print on Demand',
      },
    },
  ];

  const { modal, user } = getPODModalTag('Edit Mode', returnToEditModalEvent, options.projectID);

  return {
    modal,
    product,
    user,
  };
};
